<template>
  <div id="app" :class="$route.path == '/' ? 'home-style':'list-b-style' ">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  beforeDestroy(){
    localStorage.removeItem("activeKey")
  }
}
</script>

<style scoped>
.home-style{
  background: #fff;
}
.list-b-style{
  background: #f0f2f7;
}

</style>